RivalIQ.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    // This collection only listens to the last fetch called and
    // aborts other outstanding xhr requests. This is useful for
    // things like search results for which we only want to show the
    // latest results.
    collections.AtomicCollection = Backbone.Collection.extend({

        fetch: function (options) {
            const me = this;

            if (me.disabled) {
                return Backbone.Collection.prototype.fetch.apply(me, arguments);
            }

            if (me.inFlight) {
                me.inFlight.abort();
                me.inFlight = null;
            }

            const cleanup = {
                success: function (xhr) {
                    if (me.inFlight === xhr) {
                        me.inFlight = null;
                    }
                }
            };

            options = _.extend(options, cleanup);
            const xhr = me.inFlight = Backbone.Collection.prototype.fetch.call(me, options);
            return xhr;
        }
    });
});
